import { useCallback } from 'react';

import { useCreateConsignmentLineMutation } from '../api/consignmentsApi';
import type { ConsignmentLineCreateParams, ConsignmentLineWriteRequest, ConsignmentLineDetailResponse } from './types';

export interface UseCreateConsignmentLineOptions {
  onSuccess?: (data: ConsignmentLineDetailResponse) => void;
  onError?: (error: unknown) => void;
}

export const useCreateConsignmentLine = (options?: UseCreateConsignmentLineOptions) => {
  const [createConsignmentLine, { isLoading, isSuccess, isError, error, data }] = useCreateConsignmentLineMutation();

  const handleCreate = useCallback(
    async (params: ConsignmentLineCreateParams, data: ConsignmentLineWriteRequest) => {
      try {
        const response = await createConsignmentLine({
          params,
          data
        }).unwrap();

        options?.onSuccess?.(response);
        return response;
      } catch (error) {
        options?.onError?.(error);
        throw error;
      }
    },
    [createConsignmentLine, options]
  );

  return {
    createConsignmentLine: handleCreate,
    isLoading,
    isSuccess,
    isError,
    error,
    data
  };
};
